function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchTableau from '@/components/SearchTableau';
import FormMetaDataset from './components/FormMetaDataset';
import PaginationTableau from '@/components/PaginationTableau';
import PaginationVue from '@/components/PaginationVue.vue';
import DialogsComponent from '@/components/DialogsComponent.vue';
import StateComponent from '@/components/StateComponent.vue';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
import FormMetadata from '@/components/FormMetadata.vue';
import utils from '@/js/utils';
import { textsDefaul, envConfig, ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW, TYPE_CHANGE_METADA } from '@/js/constants';
var NOT_DATASOURCES = 'There are not dataset to assign';
export default {
  name: 'ContDatasetAssignment',
  components: {
    SearchTableau: SearchTableau,
    FormMetaDataset: FormMetaDataset,
    PaginationTableau: PaginationTableau,
    PaginationVue: PaginationVue,
    DialogsComponent: DialogsComponent,
    StateComponent: StateComponent,
    FormMetadata: FormMetadata
  },
  data: function data() {
    return {
      items: [],
      // Representa la colección de objetos
      data_list: [],
      data_ds: {},
      // representa los datos generales
      isBusy: false,
      messageLoading: textsDefaul.LOADING,
      messageEmptyList: NOT_DATASOURCES,
      path_name: '',
      limit: envConfig.pagintaionSize,
      page: 1,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      PAGE_TAGS_SIZE: envConfig.pagintaionTagsSize,
      PAGE_SIZE: envConfig.pagintaionSize,
      show_table: false,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      key_table: 1,
      is_prod_called: false,
      is_dev_called: true,
      dialogFlag: false,
      collapse_filter: false,
      DIALOG_ASSIGN: "DIALOG_ASSIGN",
      key_assign: 1,
      filter_enabled: false //true,
    };
  },
  computed: {
    fields: function fields() {
      return [{
        key: 'object_name',
        label: 'Dataset',
        sortable: true
      }, {
        key: 'data_operator',
        label: this.traductor('tablas.data_operator')
      },
      // { key: 'columns.length', label: 'Columns', class: 'text-center' },
      // { key: 'total_tables', label: 'Total Tables', class: 'text-center' },
      {
        key: 'environment',
        label: this.traductor('tablas.enviroment'),
        class: 'text-center'
      }, {
        key: 'creation_date',
        label: this.traductor('tablas.creation_time'),
        class: 'text-center'
      }, {
        key: 'action',
        label: this.traductor('tablas.actions'),
        class: 'w-15 text-center'
      }];
    },
    headers: function headers() {
      return [{
        value: 'object_name',
        text: this.traductor('my_tasks.tablas_tasks.dataset'),
        sortable: true
      }, {
        value: 'data_operator',
        text: this.traductor('my_tasks.tablas_tasks.operator'),
        align: 'center'
      },
      // { key: 'columns.length', label: 'Columns', class: 'text-center' },
      // { key: 'total_tables', label: 'Total Tables', class: 'text-center' },
      {
        value: 'environment',
        text: this.traductor('my_tasks.tablas_tasks.environment'),
        class: 'text-center',
        align: 'center'
      }, {
        value: 'creation_date',
        text: this.traductor('my_tasks.tablas_tasks.creation_date'),
        class: 'text-center',
        align: 'center'
      }, {
        value: 'action',
        text: this.traductor('my_tasks.tablas_tasks.actions'),
        class: 'w-15 text-center',
        align: 'center'
      }];
    },
    isEmptyTable: function isEmptyTable() {
      return !this.items.length;
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    },
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    }
  },
  created: function created() {
    this.reloadList();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onReferenceClose: function onReferenceClose() {
      this.show_table = false;
    },
    onShowTable: function onShowTable(table) {
      var _this = this;
      var rowData = utils.cloneJSON(table);
      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: userLogin.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          _this.objToRequest = response.data;
          _this.objToRequest.item = rowData;
          _this.objToRequest.tipo = 'edicion';
          _this.show_table = true;
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    refreshItem: function refreshItem(item) {
      var index = this.items.findIndex(function (record) {
        return record.dataset_id === item.dataset_id;
      });
      this.$set(this.items, index, item);
    },
    onClickAssign: function onClickAssign(item) {
      var dataRequest = {
        domain: window.userInfo.domain,
        clauses: {
          document_id: item.id
        }
      };
      this.data_ds = null;
      /* biDatasetService.tableauDataSourceQuery(dataRequest).then((res) => {
        if (res.code === 200 && res.success) {
          this.data_ds = res.data.result
          this.path_name = `${this.data_ds.path_name}`
          this.$refs['my-modal'].show()
        }
      })*/
      this.data_ds = item;
      this.path_name = "".concat(this.data_ds.path_name);
      //this.dialogFlag=true
      this.$refs[this.DIALOG_ASSIGN].onOpen();
      //this.$refs['my-modal'].show()
    },
    processParams: function processParams(params, isProd) {
      var filters = [{
        key: 'environment',
        operator: 'in',
        value: isProd ? [ENVIRONMENT_FLOW.PROD] : [ENVIRONMENT_FLOW.DEV, ENVIRONMENT_FLOW.TEST]
      }];
      if (params && params.clauses) {
        var clauses = params.clauses;
        if (clauses.query_type !== 'advanced') {
          for (var _i = 0, _Object$keys = Object.keys(clauses); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            if (clauses[key] && clauses[key].trim()) {
              filters.push({
                key: key,
                operator: '==',
                value: clauses[key].trim()
              });
            }
          }
        }
      }
      return _objectSpread({
        domain: window.userInfo.domain,
        pagination: {
          limit: this.limit,
          offset: this.page
        },
        filters: filters
      }, params);
    },
    reloadList: function reloadList(params, isProd) {
      var _this2 = this;
      this.items = [];
      var defaultParams = this.processParams(params, isProd);
      console.log("dbug:", defaultParams);
      this.isBusy = true;
      BiDatasetService.getDatasets(defaultParams).then(function (res) {
        if (res && res.code === 200) {
          _this2.items = res.data;
          _this2.data_list = Object.assign([], res.data);
          _this2.pagination.total = res.data.length;
          _this2.currentPage = 1;
        } else if (res && res.code === 400) {
          console.info(res);
        }
      }).catch(function (e) {
        utils.printError(e);
      }).finally(function () {
        _this2.isBusy = false;
      });
    },
    onCloseModal: function onCloseModal(dataset_id) {
      var _this3 = this;
      if (dataset_id) {
        var consulta = {
          dataset_id: dataset_id
        };
        BiDatasetService.getDatasetById(consulta).then(function (res) {
          if (res && res.success) {
            console.log(res);
            var item = _this3.items.find(function (x) {
              return x.dataset_id == dataset_id;
            });
            if (item) {
              console.log('found1');
              var index = _this3.items.indexOf(item);
              _this3.items[index] = res.data;
            }
            var item2 = _this3.data_list.find(function (x) {
              return x.dataset_id == dataset_id;
            });
            if (item2) {
              console.log('found2');
              var _index = _this3.data_list.indexOf(item2);
              _this3.data_list[_index] = res.data;
            }
            _this3.key_table += 1;
          }
        });
      }
      //this.$bvModal.hide('my-modal')
      this.$refs[this.DIALOG_ASSIGN].onClose();
    },
    onSearchQuery: function onSearchQuery(data) {
      if (data.clauses && data.clauses.environment == 'prod' && !this.is_prod_called) {
        this.is_dev_called = false;
        this.is_prod_called = true;
        this.reloadList({}, true);
      } else if (data.clauses && data.clauses.environment != 'prod' && !this.is_dev_called) {
        this.is_dev_called = true;
        this.is_prod_called = false;
        this.reloadList({}, false);
      } else {
        this.pagination.current = 1;
        if (data.clauses) {
          console.log(data, this.data_list);
          if (data.clauses.query_type == 'advanced') {
            var search = data.clauses.query.toUpperCase();
            this.items = this.data_list.filter(function (x) {
              return x.data_operator.toUpperCase().indexOf(search) != -1 || x.environment.toUpperCase().indexOf(search) != -1 || x.object_name.toUpperCase().indexOf(search) != -1 || x.path_name.toUpperCase().indexOf(search) != -1;
            });
          } else {
            this.items = Object.assign([], this.data_list);
            if (data.clauses.object_name) {
              this.items = this.items.filter(function (x) {
                return x.object_name.toUpperCase().indexOf(data.clauses.object_name.toUpperCase()) != -1;
              });
            }
            if (data.clauses.path_name) {
              this.items = this.items.filter(function (x) {
                return x.path_name.toUpperCase().indexOf(data.clauses.path_name.toUpperCase()) != -1;
              });
            }
            if (data.clauses.data_operator) {
              this.items = this.items.filter(function (x) {
                return x.data_operator.toUpperCase().indexOf(data.clauses.data_operator.toUpperCase()) != -1;
              });
            }
            // if (data.clauses.environment)
            //    this.items = this.items.filter(x => x.environment.toUpperCase().indexOf(data.clauses.environment.toUpperCase()) != -1)
          }
        } else {
          this.items = Object.assign([], this.data_list);
        }
        this.pagination.total = this.items.length;
      }
    },
    onPage: function onPage(page) {
      this.page = page;
      this.reloadList({
        page: page
      });
    },
    changePagina: function changePagina(pagina) {}
  }
};